import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { Input, PasswordInput } from '../components/Input';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState('');

  const validate = () => {
    const newErrors = {};
    if (!formData.username.trim()) newErrors.username = 'Uživatelské jméno je povinné';
    if (!formData.password) newErrors.password = 'Heslo je povinné';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    if (!validate()) return;
    setLoading(true);

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        onLogin?.(data.user || { name: formData.username, role: 'user' });
        navigate('/');
      } else {
        setLoginError(data.error || 'Nesprávné uživatelské jméno nebo heslo');
      }
    } catch (error) {
      setLoginError('Přihlášení se nezdařilo. Zkuste to prosím znovu.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
    if (loginError) setLoginError('');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F5F5F5', padding: '24px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '16px', backgroundColor: '#E53935', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', color: '#FFFFFF', fontSize: '24px', fontWeight: 700, boxShadow: '0 10px 15px rgba(229, 57, 53, 0.3)' }}>BG</div>
          <h1 style={{ fontSize: '28px', fontWeight: 700, color: '#333333', margin: '0 0 8px' }}>BASICGAME ERP</h1>
          <p style={{ fontSize: '14px', color: '#666666', margin: 0 }}>Systém pro správu zákazníků a trenažérů</p>
        </div>

        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '16px', padding: '32px', boxShadow: '0 10px 15px rgba(0, 0, 0, 0.07)', border: '1px solid #E0E0E0' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 600, color: '#333333', margin: '0 0 24px', textAlign: 'center' }}>Přihlášení</h2>

          {loginError && (
            <div style={{ backgroundColor: '#FFEBEE', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#F44336', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFFFFF', fontSize: '12px', fontWeight: 700 }}>!</div>
              <p style={{ fontSize: '13px', color: '#C62828', margin: 0 }}>{loginError}</p>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <Input label="Uživatelské jméno" name="username" value={formData.username} onChange={handleChange} placeholder="Zadejte uživatelské jméno" error={errors.username} fullWidth autoComplete="username" autoFocus />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <PasswordInput label="Heslo" name="password" value={formData.password} onChange={handleChange} placeholder="Zadejte heslo" error={errors.password} fullWidth autoComplete="current-password" />
            </div>
            <Button type="submit" variant="primary" fullWidth loading={loading} size="lg">Přihlásit se</Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
